// Venturi meter vertex schema
// Flow measurement device. Single elevation.

import { z } from 'zod';
import { BaseVertexSchema } from '../base/vertex';
import { ValueWithUnitSchema, MeterMaterialSchema } from '../base/common';

const MfgMethodSchema = z.enum(['as_cast', 'machined', 'rough_welded']);
const DivergenceAngleSchema = z.enum(['seven_degrees', 'fifteen_degrees']);

export const VenturiMeterVertexSchema = BaseVertexSchema.extend({
  type: z.literal('venturi_meter'),
  elevation: ValueWithUnitSchema,
  mfg_method: MfgMethodSchema,
  divergence_angle: DivergenceAngleSchema,
  meter_diameter: ValueWithUnitSchema,
  device_material: MeterMaterialSchema.optional(),
  pipe_material: MeterMaterialSchema.optional(),
});

export type VenturiMeterVertex = z.infer<typeof VenturiMeterVertexSchema>;
